import {
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    SALESORDERS,
    TASKS,
} from 'constants/Entities';

// Complete B2 <-> B4 field name mappings by entity
export const FIELD_TRANSLATIONS = {
    [ACTIVITIES.trueName]: {
        _idComercial: 'salesRepId',
        gestionTime: 'date',
        // Note about idContacto[n]:
        // Special handling needed because it's an array field in B4, see SPECIAL_FIELD_MAPPINGS.
        idContacto: 'contactId',
        idContacto2: 'contactId',
        idContacto3: 'contactId',
        idContacto4: 'contactId',
        idContacto5: 'contactId',
        idEmpresa: 'accountId',
        idExpediente: 'opportunityId',
        idTipoGestion: 'typeId',
        text: 'comment',
        WhatsappMessage: 'whatsappMessage',
    },
    [AGENDA.trueName]: {
        account: 'accountId',
        asunto: 'subject',
        comment: 'comment',
        contact: 'contactId',
        hfin: 'endDate',
        hini: 'startDate',
        idExpediente: 'opportunityId',
        idTipoGestion: 'typeId',
        isTarea: 'isTask',
        isTodoDia: 'allDay',
    },
    [COMPANIES.trueName]: {
        address1: 'address1',
        address2: 'address2',
        cellPhone: 'phone3',
        city: 'city',
        comments: 'comment',
        cp: 'postcode',
        email1: 'email',
        fax: 'fax',
        idCalificacion: 'segmentId',
        idCompanyState: 'statusId',
        idCompanyType: 'typeId',
        idCountry: 'countryId',
        idEnvironment: 'branchId',
        idResponsable: 'salesRepId1',
        idResponsable2: 'salesRepId2',
        idResponsable3: 'salesRepId3',
        idResponsable4: 'salesRepId4',
        idResponsable5: 'salesRepId5',
        idTarifa: 'rateId',
        latitude: 'latitude',
        longitude: 'longitude',
        name: 'name',
        nif: 'vatNumber',
        phone: 'phone',
        phone2: 'phone2',
        province: 'region',
        web: 'web',
    },
    [CONTACTS.trueName]: {
        blnUseCompanyAddress: 'UseCompanyAddress',
        CellPhone: 'phone2',
        City: 'city',
        Comments: 'comment',
        Email: 'email',
        Gender: 'gender',
        IdCompany: 'accountId',
        IdContactType: 'typeId',
        IdCountry: 'countryId',
        IdSkype: 'skype',
        idSucursal: 'idSucursal',
        LinkedIn: 'linkedin',
        Name: 'firstName',
        PersonalAddress: 'address1',
        Phone: 'phone1',
        PostalCode: 'postcode',
        Province: 'region',
        Surnames: 'lastName',
    },
    [OPPORTUNITIES.trueName]: {
        address1: 'address1',
        address2: 'address2',
        amount: 'total',
        city: 'city',
        closeDate: 'closedDate',
        comments: 'comments',
        cp: 'postcode',
        currency: 'currencyId',
        environment: 'branchId',
        expectedCloseDate: 'salesForecastDate',
        fechaGanada: 'wonDate',
        idCountry: 'countryId',
        idEmpresa1: 'accountId1',
        idEmpresa2: 'accountId2',
        idEmpresa3: 'accountId3',
        latitude: 'latitude',
        longitude: 'longitude',
        probability: 'salesProbability',
        province: 'region',
        reference: 'reference',
        state: 'statusId',
        type: 'typeId',
    },
    [SALESORDERS.trueName]: {
        comments: 'comment',
        expectedCloseDate: 'salesForcecastDate',
        idBranch: 'salesRepId',
        idCompany: 'accountId',
        idCurrency: 'currencyId',
        idOpportunity: 'opportunityId',
        idRate: 'rateId',
        idStateSalesOrder: 'statusId',
        internalComments: 'internalComment',
        products: 'products',
        reference: 'reference',
    },
    [TASKS.trueName]: {
        account: 'accountId',
        asunto: 'subject',
        comment: 'comment',
        contact: 'contactId',
        hfin: 'endDate',
        hini: 'startDate',
        idExpediente: 'opportunityId',
        idTipoGestion: 'typeId',
        isTarea: 'isTask',
        isTodoDia: 'allDay',
    },
};

// Special mappings: Array fields in B4 that split into multiple B2 fields
export const SPECIAL_FIELD_MAPPINGS = {
    [ACTIVITIES.trueName]: {
        contactId: {
            b4Field: 'contactId',
            b2Fields: ['idContacto', 'idContacto2', 'idContacto3', 'idContacto4', 'idContacto5'],
        },
    },
    [AGENDA.trueName]: {},
    [COMPANIES.trueName]: {},
    [CONTACTS.trueName]: {},
    [OPPORTUNITIES.trueName]: {},
    [SALESORDERS.trueName]: {
        contactId: {
            b4Field: 'contactId',
            b2Fields: ['idContact'],
        },
    },
    [TASKS.trueName]: {},
};
